<template>
  <div class="dvLoader-container animate_loaderOut contentLoader">
    <div class="dvLoader-bar">
      <v-progress-linear
        indeterminate
        background-color="#757575"
        color="#18FFFF"
        height="5"
        absolute
        top
      ></v-progress-linear>
    </div>

    <div class="dvLoader-circular animate_loader fadeIn">
      <v-progress-circular
        :size="45"
        :width="3"
        color="#CCCCCC"
        indeterminate
      ></v-progress-circular>
    </div>
  </div> <!-- dvLoader-container-->
</template>

<script>
  export default {
    name: 'body-loader',
    props: ['loading', 'firstLoad'],
    data: () => ({
    }),
    watch: {
      loading: function() {
        if(this.firstLoad){
          return false
        }
        let self = this
        if(!this.loading){
          setTimeout(function(){
            self.$jQuery(".contentLoader").fadeOut();
          }, 200);
        }else{
          self.$jQuery(".contentLoader").show();
        }
      }
    },
    computed: {
    },
    methods: {
    },
    mounted() {
      this.$jQuery(".contentLoader").hide();
    },
    created () {
    },
    components: {
    }
  }
</script>
